const mutationTypes = {
  SET_KEYCODE_RESPONSE: 'setKeycodeResponse', // キーコード取得時のレスポンス設定
  SET_QRCODE: 'setQrCode', // QRコード設定
  CLEAR_KEYCODE_RESPONSE: 'clearKeycodeResponse', // キーコード取得時のレスポンスクリア
  SET_MESSAGES: 'setMessages', // メッセージ設定
};
export default mutationTypes;
